import { JSONEditor } from '@json-editor/json-editor'

const BaseEditor = JSONEditor.defaults.editors.table

class TableEditor extends BaseEditor {
  
}

export default TableEditor
